module.exports = __webpack_public_path__ + "static/img/service-process.748f4c1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/产品及服务/细胞株构建/service-process.png
// module id = 9FpC
// module chunks = 16